import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

const DEFAULT_TITLES = {
  kvkk: 'KVKK Metni',
  terms: 'Kullanım Koşulları',
  privacy: 'Gizlilik Politikası',
  about: 'Hakkımızda',
  contact: 'İletişim'
};

export default function PolicyModal({ policyKey, open, onClose }) {
  const [loading, setLoading] = useState(false);
  const [policy, setPolicy] = useState({ title: '', content: '' });

  useEffect(() => {
    if (!open || !policyKey) return;

    let cancelled = false;

    const fetchPolicy = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/api/policies/${policyKey}`);
        const data = await res.json();
        if (!cancelled) {
          setPolicy({
            title: data.title || DEFAULT_TITLES[policyKey] || 'Politika Metni',
            content: data.content || '<p>İçerik henüz girilmemiş.</p>'
          });
        }
      } catch (err) {
        if (!cancelled) {
          setPolicy({
            title: DEFAULT_TITLES[policyKey] || 'Politika Metni',
            content: '<p>Politika metni yüklenirken bir hata oluştu.</p>'
          });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchPolicy();

    return () => {
      cancelled = true;
    };
  }, [open, policyKey]);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/55 backdrop-blur-sm p-4">
      <div className="w-full max-w-[calc(100vw-2rem)] sm:max-w-3xl max-h-[85vh] overflow-hidden rounded-[28px] bg-white dark:bg-[#101922] border border-slate-200 dark:border-slate-800 shadow-2xl">
        <div className="flex items-start justify-between gap-4 px-6 py-5 border-b border-slate-200 dark:border-slate-800">
          <div className="min-w-0">
            <p className="text-[10px] font-black uppercase tracking-[0.28em] text-slate-400">Yasal Metin</p>
            <h3 className="mt-1 break-words text-xl font-black text-slate-900 dark:text-white">{policy.title}</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="size-10 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-500 hover:text-slate-800 dark:hover:text-white transition"
            aria-label="Kapat"
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <div className="max-h-[calc(85vh-92px)] overflow-y-auto overflow-x-hidden hide-scrollbar px-6 py-5">
          {loading ? (
            <div className="py-16 text-center text-sm font-bold text-slate-500 dark:text-slate-400">
              Politika metni yükleniyor...
            </div>
          ) : (
            <div
              className="bbtv-rich-text prose prose-slate w-full max-w-full overflow-x-hidden dark:prose-invert prose-p:leading-7 prose-li:leading-7"
              dangerouslySetInnerHTML={{ __html: policy.content }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
